import { Input } from "antd";
import React, { useState } from "react";

export function subtractEstimate(prevEstimate, newEstimate) {
  // Helper function to convert estimate string to minutes
  function estimateToMinutes(estimate) {
    const match = estimate.match(/\d+w|\d+d|\d+h|\d+m/g);
    let totalMinutes = 0;

    if (match) {
      match.forEach((val) => {
        const unit = val.slice(-1);
        const amount = parseInt(val.slice(0, -1));

        switch (unit) {
          case "w":
            totalMinutes += amount * 7 * 8 * 60;
            break;
          case "d":
            totalMinutes += amount * 8 * 60;
            break;
          case "h":
            totalMinutes += amount * 60;
            break;
          case "m":
            totalMinutes += amount;
            break;
        }
      });
    }

    return totalMinutes;
  }

  // Convert both estimates to total minutes
  const prevMinutes = estimateToMinutes(prevEstimate);
  const newMinutes = estimateToMinutes(newEstimate);

  // Subtract new estimate from previous estimate
  let totalMinutes = prevMinutes - newMinutes;

  // Handle negative results by converting totalMinutes to absolute value
  const isNegative = totalMinutes < 0;
  if (isNegative) totalMinutes = Math.abs(totalMinutes);

  // Convert total minutes back to weeks, days, hours, and minutes
  const weeks = Math.floor(totalMinutes / (7 * 8 * 60));
  totalMinutes %= 7 * 8 * 60;
  const days = Math.floor(totalMinutes / (8 * 60));
  totalMinutes %= 8 * 60;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  // Format the estimate string in the desired format "0w 0d 00h 00m"
  let updatedEstimate = "";
  if (isNegative) updatedEstimate += "-"; // Add negative sign if the result was negative
  if (weeks) updatedEstimate += `${weeks}w `;
  if (days) updatedEstimate += `${days}d `;
  if (hours) updatedEstimate += `${hours}h `;
  if (minutes || (!weeks && !days && !hours)) updatedEstimate += `${minutes}m `;

  // Trim any extra space at the end and return
  return updatedEstimate.trim();
}

export function updateEstimate(prevEstimate, newEstimate) {
  // Extract the values of weeks, days, hours, and minutes from the estimate strings using regular expressions
  const prevMatch = prevEstimate.match(/\d+w|\d+d|\d+h|\d+m/g);
  const newMatch = newEstimate.match(/\d+w|\d+d|\d+h|\d+m/g);

  // Convert the values to a total number of minutes
  let prevMinutes = 0;
  let newMinutes = 0;
  if (prevMatch) {
    prevMatch.forEach((val) => {
      const unit = val.slice(-1);
      const amount = parseInt(val.slice(0, -1));
      console.log(unit, amount, "prevmatch");
      switch (unit) {
        case "w":
          prevMinutes += amount * 7 * 8 * 60;
          break;
        case "d":
          prevMinutes += amount * 8 * 60;
          break;
        case "h":
          prevMinutes += amount * 60;
          break;
        case "m":
          prevMinutes += amount;
          break;
      }
    });
  }

  if (newMatch) {
    newMatch.forEach((val) => {
      const unit = val.slice(-1);
      const amount = parseInt(val.slice(0, -1));
      console.log(unit, amount, "newmatch");
      switch (unit) {
        case "w":
          newMinutes += amount * 7 * 8 * 60;
          break;
        case "d":
          newMinutes += amount * 8 * 60;
          break;
        case "h":
          newMinutes += amount * 60;
          break;
        case "m":
          newMinutes += amount;
          break;
      }
    });
  }

  console.log(prevMinutes, newMinutes);
  // Add the new estimate in minutes to the previous estimate's total
  let totalMinutes = prevMinutes + newMinutes;

  // Convert the total number of minutes back to weeks, days, hours, and minutes
  const weeks = Math.floor(totalMinutes / (7 * 8 * 60));
  totalMinutes %= 7 * 8 * 60;
  const days = Math.floor(totalMinutes / (8 * 60));
  totalMinutes %= 8 * 60;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  console.log(weeks, days, hours, minutes, totalMinutes);
  // Format the estimate string in the desired format "0w 0d 00h 00m"
  let updatedEstimate = "";
  if (weeks) updatedEstimate += `${weeks}w `;
  if (days) updatedEstimate += `${days}d `;
  if (hours) updatedEstimate += `${hours}h `;
  if (minutes) updatedEstimate += `${minutes}m `;

  // Return the updated estimate
  return updatedEstimate;
}

const TimeInput = ({
  disabled = false,
  value = "",
  onChange,
  className,
  onOk,
  addNewTimeToPreviousTime = false,
  autoFocus = false,
}) => {
  const [estimate, setEstimate] = useState("");

  const [isEditing, setIsEditing] = useState(autoFocus);
  const [error, setError] = useState(false);

  const handleChange = (event) => {
    const value = event.target.value;
    // Only allow values that contain digits and the characters "w", "d", "h", and "m"
    setEstimate(value);
  };

  const handleSave = () => {
    console.log(value, "handleSave");
    if (
      /^(?:\s*\d+w)?(?:\s*\d+d)?(?:\s*\d+h)?(?:\s*\d+m)?\s*$/.test(estimate)
    ) {
      if (addNewTimeToPreviousTime) {
        const newEstimate = updateEstimate(value, estimate);
        onChange(newEstimate);
        // console.log(
        //   newEstimate,
        //   estimate,
        //   value,
        //   "(newEstimate, estimate, value)"
        // );
        onOk(newEstimate, estimate);
      } else {
        onChange(estimate);
        onOk(estimate, estimate);
      }

      setIsEditing(false);

      setError(false);
      setEstimate("");
      return;
    }

    setError(true);
  };

  const handelCancel = () => {
    setEstimate("");
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <>
        <div
          className={`w-full  bg-white rounded h-[30px] border-[1px] ${
            error
              ? "border-error-600 shadow-input-error"
              : "border-[#7DC7FF] shadow-input-focus"
          } ${className}`}
        >
          <div className="flex justify-center h-full items-center">
            <Input
              bordered={false}
              className=" bg-transparent w-full h-full px-2 py-2.5  new-task-textarea "
              style={{
                outline: "none",
              }}
              value={estimate}
              onChange={handleChange}
              autoFocus
              onPressEnter={() => handleSave()}
              onBlur={() => null}
              placeholder="0w 0d 00h 00m"
            />

            <div
              className="cursor-pointer "
              onClick={(e) => {
                e.stopPropagation();
                handleSave();
              }}
            >
              <img
                src="/images/icons/input_save.svg"
                className="h-5 w-5"
                alt=""
              />
            </div>
            <div
              className="cursor-pointer mx-2 ml-1"
              onClick={() => handelCancel()}
            >
              <img
                src="/images/icons/sector-icons/input-cross.svg"
                className="h-5 w-5"
                alt=""
              />
            </div>
          </div>
        </div>
        {error && (
          <div className="out-300-12 mt-1 text-left text-error-500">
            The time should be in 0w 0d 00h 00m
          </div>
        )}
      </>
    );
  }
  return (
    <div
      className={`h-[30px] whitespace-nowrap flex items-center  cursor-pointer border border-transparent hover:border-gray-200 w-full rounded pl-2   ${
        value ? "text-black out-500-14" : "text-gray-500 out-300-14"
      }`}
      onClick={(e) => {
        e.stopPropagation();
        !disabled && setIsEditing(true);
      }}
    >
      {value || "0w 0d 00h 00m"}
    </div>
  );
};

export default TimeInput;
